import { ImageTransform } from './image'

export interface Company {
  id: number
  name: string
  code: string
  description: string | null
  image_id: number | null
  image: ImageTransform | null
  experts: any[]
  status_id: number
  created_at: string
  updated_at: string
}

export enum CompanySatus {
  ACTIVE = 1,
  INACTIVE = 0,
  DELETED = 2,
}
